<template>
  <div class="h-8">
    <img
      v-if="logo"
      :src="logo.src"
      :class="logoClasses"
      :style="logoStyle"
      :alt="nomeEmpresa"
    />
  </div>
</template>

<script>
import logoHeader from "@/assets/logoHeader.png";
import logoVortex from "@/assets/dnways.png";
import logoActual from "@/assets/logoActual_v2.png";
import logoGenial from "@/assets/logogenial.png";
import logoRji from "@/assets/logo/rji.png";
import logoLastro from "@/assets/logoLastro.jpg";
import logoOslo from "@/assets/logo/oslo.svg";
import logoIntra from "@/assets/logo/intra.svg";

const headerLogo = { src: logoHeader, darkClass: "dark:brightness-200" };
const logos = {
  BRITECH: headerLogo,
  DNWAYS_DEMO_Y: headerLogo,
  DNWAYS_DEMO_X: headerLogo,
  DNWAYS: headerLogo,
  VORTEX: { src: logoVortex, darkClass: "dark:brightness-200" },
  ACTUAL: { src: logoActual, darkClass: "dark:logo-invert-dark" },
  GENIAL: {
    src: logoGenial,
    lightFilter: "none",
    darkFilter: "invert(1)",
    pjDarkFilter: "brightness(0) invert(1)",
    darkClass: "dark:brightness-200",
    pjDarkClass: "",
  },
  RJI: {
    src: logoRji,
    height: "h-12",
    darkClass: "dark:brightness-200",
    lightFilter: "invert(1)",
    darkFilter: "none",
    pjDarkFilter: "brightness(0) invert(1)",
  },
  LASTRO: { src: logoLastro, darkClass: "dark:brightness-200" },
  INTRA: {
    src: logoIntra,
    lightFilter: "brightness(0)",
    darkFilter: "none",
  },
  OSLO: {
    src: logoOslo,
    height: "h-8",
    darkClass: "dark:brightness-200",
    lightFilter: "none",
    darkFilter: "brightness(0) invert(1)",
  },
};

export default {
  name: "CompanyLogo",
  props: {
    nomeEmpresa: {
      type: String,
      default: () => process.env.VUE_APP_NOME_EMPRESA || "",
    },
    isDark: { type: Boolean, default: false },
    variant: { type: String, default: "cadastro" },
  },
  computed: {
    logo() {
      const company = this.nomeEmpresa.trim().toUpperCase();
      return Object.prototype.hasOwnProperty.call(logos, company) ? logos[company] : null;
    },
    logoClasses() {
      if (!this.logo) return [];
      const height = this.logo.height || (this.variant === "dashboard" ? "h-12" : "h-8");
      const darkClass = this.variant === "pj"
        ? this.logo.pjDarkClass ?? this.logo.darkClass
        : this.logo.darkClass;
      return [height, "w-auto", darkClass];
    },
    logoStyle() {
      if (!this.logo || !this.logo.lightFilter) return {};
      const darkFilter = this.variant === "pj"
        ? this.logo.pjDarkFilter || this.logo.darkFilter
        : this.logo.darkFilter;
      return { filter: this.isDark ? darkFilter : this.logo.lightFilter };
    },
  },
};
</script>
